// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"77":"a3c3dc09","234":"1dcb6c3e","368":"b5cd2f07","417":"a9eb31cb","466":"c8d9e752","553":"a5346fe9","567":"f8ba3e85","590":"928f22da","599":"4f08af35","625":"f16905f1","757":"6827ddbf","849":"ade1ac45","945":"487ab311"}[chunkId] + ".js";
};